import { mutate } from 'swr';
import axios from 'axios';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { SERVICES } from '@shared/constants/apiConfig';
import { getError } from '@shared/utils/helpers';
import { ILenderUtility, TCard } from '../../../../interfaces';
import { requestUpdateGeneral } from '../../../requests';

export const requestCreateCard = (lenderId: string, card: TCard, lenderData?: ILenderUtility) => {
  const path = `/${SERVICES.LENDER}/lenders/${lenderId}/card`;
  return mutate(`/${SERVICES.LENDER}/lenders/${lenderId}`, async() => {
    try {
      await axios.put(path, {
        fromDate: card.fromDate,
        toDate: card.toDate,
      });
      Notistack.successMessage('Card - Created Successfully');
      if (lenderData) {
        await requestUpdateGeneral(lenderData);
        window.location.reload();
      }
    } catch (err) {
      const error = getError(err);
      Notistack.generalError(error);
      return { error };
    }
  });
};

export const requestUpdateCard = (lenderId: string, card: TCard, lenderData?: ILenderUtility) => {
  const path = `/${SERVICES.LENDER}/lenders/${lenderId}/card`;
  return mutate(`/${SERVICES.LENDER}/lenders/${lenderId}`, async() => {
    try {
      await axios.patch(path, {
        id: card.id,
        fromDate: card.fromDate,
        toDate: card.toDate,
      });
      Notistack.successMessage('Card - Updated Successfully');
      if (lenderData) {
        await requestUpdateGeneral(lenderData);
        window.location.reload();
      }
    } catch (err) {
      const error = getError(err);
      Notistack.generalError(error);
      return { error };
    }
  });
};

export const requestCopyCard = (lenderId: string, cardId = '') => {
  const path = `/${SERVICES.LENDER}/lenders/${lenderId}/card-copy/${cardId}`;
  return mutate(`/${SERVICES.LENDER}/lenders/${lenderId}`, async() => {
    try {
      await axios.post(path, path);
      Notistack.successMessage('Card - Copied Successfully');
    } catch (err) {
      const error = getError(err);
      Notistack.generalError(error);
      return { error };
    }
  });
};

export const requestDeleteCard = (lenderId: string, cardId = '', lenderData?: ILenderUtility) => {
  const path = `/${SERVICES.LENDER}/lenders/${lenderId}/card/${cardId}`;
  return mutate(`/${SERVICES.LENDER}/lenders/${lenderId}`, async() => {
    try {
      await axios.delete(path);
      Notistack.successMessage('Card - Deleted Successfully');
      if (lenderData) {
        await requestUpdateGeneral(lenderData);
        window.location.reload();
      }
    } catch (err) {
      const error = getError(err);
      Notistack.generalError(error);
      return { error };
    }
  });
};
